<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
  <c-container [fluid]="true" class="border-bottom px-4">
    <button [cSidebarToggle]="sidebarId" cHeaderToggler class="btn" toggle="visible"
      style="margin-inline-start: -14px;">
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>

    <div style="flex: 1"></div>

    <!-- Language Picker -->
    <div class="sv-lang-picker" style="margin-right: 8px;">
      <button class="sv-lang-btn" (click)="toggleLangDropdown()">
        <img [src]="currentLang.icon" [alt]="currentLang.label">
        <span>{{ currentLang.label }}</span>
        <svg width="10" height="6" viewBox="0 0 10 6" fill="currentColor"><path d="M1 1l4 4 4-4"/></svg>
      </button>
      <div class="sv-lang-dropdown" [class.open]="langDropdownOpen">
        <button *ngFor="let lang of languages" class="sv-lang-option" (click)="selectLanguage(lang)">
          <img [src]="lang.icon" [alt]="lang.label">
          <span>{{ lang.label }}</span>
        </button>
      </div>
    </div>

  </c-container>
</ng-container>
<!--</c-header>-->

<ng-template #themeDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle>
      @switch (colorMode()) {
      @case ("dark") {
      <svg cIcon name="cilMoon" size="lg"></svg>
      }
      @case ("auto") {
      <svg cIcon name="cilContrast" size="lg"></svg>
      }
      @default {
      <svg cIcon name="cilSun" size="lg"></svg>
      }
      }
    </button>
    <div cDropdownMenu>
      <button (click)="colorMode.set('light')" [active]="colorMode()==='light'" [routerLink]="[]" cDropdownItem
        class="d-flex align-items-center">
        <svg cIcon class="me-2" name="cilSun" size="lg"></svg>
        {{ 'header.light' | translate }}
      </button>
      <button (click)="colorMode.set('dark')" [active]="colorMode()==='dark'" [routerLink]="[]" cDropdownItem
        class="d-flex align-items-center">
        <svg cIcon class="me-2" name="cilMoon" size="lg"></svg>
        {{ 'header.dark' | translate }}
      </button>
      <button (click)="colorMode.set('auto')" [active]="colorMode()==='auto'" [routerLink]="[]" cDropdownItem
        class="d-flex align-items-center">
        <svg cIcon class="me-2" name="cilContrast" size="lg"></svg>
        {{ 'header.auto' | translate }}
      </button>
    </div>
  </c-dropdown>
</ng-template>
